import React from "react";

import "./index.css";
import { Button, Icon } from "semantic-ui-react";

const Card = ({
  imagem,
  titulo,
  renderPreview,
  identificator,
  imageError,
  downloadLink,
}) => {
  return (
    <div>
      <div className="cardCertificados">
        <div className="card__img">
          <img
            className="card__img-preview"
            onError={(e) => imageError(e)}
            src={imagem}
            height="100"
            width="200"
            alt="Image name"
          />
        </div>
        <div className="headerCertificados">
          <div className="card__content">
            <p className="card__text">
              <i className="fa fa-map-marker" aria-hidden="true"></i> {titulo}
            </p>
          </div>
          <div className="card__bottom">
            <Button
              style={{ background: "none", border: "none" }}
              className="displayend"
              onClick={() => renderPreview(identificator)}
            >
              Visualizar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
